import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage.js';
import Photography from './photography.js';
import Projects from './projects.js';

function App() {
  return (
    <Router>
      <div className="bg-stone-800 text-white min-h-screen">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/photography" element={<Photography />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="*" element={<h1>404 Not Found</h1>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
